module.exports = __webpack_public_path__ + "img/ivory-coast.1181db19.svg";